import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/Layout';
import '../../assets/scss/challenge.scss'; // Re-use challenge styles or create new

const COLORS = ['#FFB800', '#4ECB71', '#FF6B6B', '#3B82F6', '#8B5CF6'];

const Curriculum = () => {
    const [unlockedDay, setUnlockedDay] = useState(1);

    useEffect(() => {
        axios.get('/api/progress')
            .then(res => setUnlockedDay(res.data.unlockedDay))
            .catch(err => console.error(err));
    }, []);

    // Newest unlocked Day first; one more Day opens per attendance (finished session)
    const chapters = Array.from({ length: unlockedDay }, (_, i) => unlockedDay - i);

    return (
        <Layout header={{ title: '커리큘럼', Backbtn: true, link: '/Study/Free' }} containName='curriculum'>
            <div className="curriculum-wrap" style={{ padding: '20px' }}>
                <h2 style={{ fontSize: '20px', marginBottom: '8px', fontWeight: 'bold' }}>오늘의 학습을 선택하세요</h2>
                <p style={{ fontSize: '14px', color: '#888', marginBottom: '20px' }}>하루에 한 번 학습을 마치면, 출석일 수만큼 Day가 열려요.</p>

                <div className="chapter-list" style={{ display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)', gap: '15px' }}>
                    {chapters.map(id => (
                        <Link
                            key={id}
                            to={`/Study/View?chapter=${id}&count=20`}
                            className="chapter-item"
                            style={{
                                display: 'block',
                                padding: '20px',
                                backgroundColor: '#fff',
                                borderRadius: '15px',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                                textDecoration: 'none',
                                borderLeft: `5px solid ${COLORS[(id - 1) % COLORS.length]}`
                            }}
                        >
                            <strong style={{ display: 'block', fontSize: '18px', color: '#333' }}>
                                Day {id}{id === unlockedDay && ' · NEW'}
                            </strong>
                        </Link>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default Curriculum;
